// removed by extract-text-webpack-plugin
module.exports = {"logoutTimer":"LogoutTimer__logoutTimer___31vWW"};


//////////////////
// WEBPACK FOOTER
// ./src/dialogs/VPRekla/LogoutTimer/LogoutTimer.scss
// module id = 743
// module chunks = 0